import { Chain } from '@wagmi/core'

export const inEVM = {
  id: 2525,
  name: 'INEVM Mainnet',
  network: 'INEVM Mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'INJ',
    symbol: 'INJ',
  },
  rpcUrls: {
    public: { http: ['https://inevm.calderachain.xyz/http'] },
    default: { http: ['https://inevm.calderachain.xyz/http'] },
  },
  blockExplorers: {
    etherscan: { name: 'INEVM', url: 'https://explorer.injective.network/' },
    default: { name: 'INEVM', url: 'https://explorer.injective.network/' },
  },
  /* contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 11_907_934,
    },
  }, */
} as const satisfies Chain